import type { IMaskFunction } from 'interfaces/IMask';

const expirydate: IMaskFunction = {
  apply: (value: string) => {
    if (!value) {
      return value;
    }

    const regexp = /^(\d{0,2})(\d{0,2})/;
    const replacement = value.length < 3 ? '$1' : '$1/$2';

    return value.replace(/\D/g, '').replace(regexp, replacement);
  },
  clean: (value: string) => value.substr(0, 5)
};

export default expirydate;
